import React from 'react';
import { useTranslation } from 'react-i18next';
import { Login } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';

export function LoginPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('login-component.metatags.title'),
        description: t('login-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.login,
        index: false,
    });

    return <Login />;
}
